@if (variant() === "circle") {
  <div class="tw-relative tw-flex tw-items-center tw-justify-center" [ngClass]="size()">
    <svg class="tw-w-full tw-h-full tw-transform -tw-rotate-90" viewBox="0 0 100 100">
      <circle
        cx="50"
        cy="50"
        r="40"
        class="meter-track"
        fill="transparent"
        [attr.stroke-width]="strokeWidth()"
      />
      <circle
        cx="50"
        cy="50"
        r="40"
        fill="transparent"
        stroke-linecap="round"
        [ngClass]="meterColor()"
        [attr.stroke-width]="strokeWidth()"
        [style.strokeDasharray]="strokeArray"
        [style.strokeDashoffset]="strokeOffset()"
      />
    </svg>

    <div class="tw-absolute tw-text-center tw-text-xl tw-font-semibold tw-text-color-text-default">
      {{ percentage() | number: "1.0-0" }}%
      <div class="tw-text-sm tw-font-normal tw-text-neutral-600">{{ "used" | i18n }}</div>
    </div>
  </div>
} @else {
  <meter [value]="value()" class="tw-w-full" [ngClass]="meterColor()"></meter>
}
